module.exports = __webpack_public_path__ + "img/logo-smaller.5566f008.jpg";